module.exports = __webpack_public_path__ + "static/media/seemypetcam-2.57a190aa.png";